var map = {
	"./Api.svg": 846,
	"./ArrowsClockwise.svg": 847,
	"./ArrowsDownUp.svg": 848,
	"./ArrowsLeftRight.svg": 417,
	"./ChartLineUp.svg": 849,
	"./Discord.svg": 516,
	"./Email.svg": 991,
	"./FeatureRequest.svg": 850,
	"./Github.svg": 851,
	"./Graymass.svg": 852,
	"./Graymass_white.svg": 853,
	"./Handshake.svg": 158,
	"./Image.svg": 854,
	"./Monogram.svg": 855,
	"./SmileyXEyes.svg": 293,
	"./Status.svg": 856,
	"./Storefront.svg": 418,
	"./Telegram.svg": 517,
	"./Treasure.svg": 992,
	"./Twitter.svg": 518,
	"./UserMinus.svg": 419,
	"./Users.svg": 420,
	"./badge-promoted.svg": 857,
	"./candle-icon.svg": 858,
	"./classic_layout.svg": 414,
	"./classic_layout_light.svg": 415,
	"./club.svg": 512,
	"./contract.svg": 993,
	"./farmer.svg": 859,
	"./gh.svg": 994,
	"./info.svg": 995,
	"./linktg.svg": 860,
	"./linktw.svg": 861,
	"./linkweb.svg": 862,
	"./listing-time.svg": 996,
	"./menu-analytics.svg": 997,
	"./menu-api.svg": 998,
	"./menu-bridge.svg": 999,
	"./menu-docs.svg": 1000,
	"./menu-farms.svg": 1001,
	"./menu-git.svg": 1002,
	"./menu-ibc.svg": 1003,
	"./menu-nft.svg": 1004,
	"./menu-otc.svg": 1005,
	"./menu-pools.svg": 1006,
	"./menu-spot.svg": 1007,
	"./modern_layout.svg": 560,
	"./modern_layout_light.svg": 561,
	"./question.svg": 1008,
	"./source-code.svg": 1009,
	"./space_1.svg": 1010,
	"./tag.svg": 1011,
	"./tg.svg": 1012,
	"./ticker.svg": 1013,
	"./tw.svg": 1014,
	"./wax.svg": 513,
	"./wcw-bridge.svg": 1015,
	"./website.svg": 1016
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;